package com.kinoshazam.data

import com.russhwolf.settings.StorageSettings
import kotlinx.browser.localStorage

class JsStorageFactory : StorageFactory {

    override fun common(): Storage = Storage(StorageSettings(localStorage))

    override fun user(): Storage = Storage(StorageSettings(localStorage))

    override fun secure(): Storage = Storage(StorageSettings(localStorage))
}
